<template>
  <popup-container @close="clickCloseButton()">
    <!-- 帐号注册 -->
    <div
      v-if="displayIndex === REGISTRATION"
      class="login-main flex flex-col text-center"
    >
      <h3 class="text-2xl mb-3">
        帐号注册
      </h3>
      <form
        :id="REGISTRATION"
        @submit.prevent="submitRegistrationForm()"
      >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="text"
          name="first_name"
          placeholder="名字"
          required
        >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="text"
          name="last_name"
          placeholder="姓氏"
          required
        >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="email"
          name="email"
          placeholder="电子邮箱"
          required
        >
        <input
          v-model="password"
          class="w-full mb-3 h-8 px-5 border"
          type="password"
          name="password"
          placeholder="密码"
          autocomplete="off"
          required
          :class="{'border-red': inValid && errorPassword}"
        >
        <input
          v-model="confirmPassword"
          class="w-full mb-3 h-8 px-5 border"
          type="password"
          placeholder="确认密码"
          autocomplete="off"
          required
          :class="{'border-red': inValid && errorPassword}"
        >
        <div class="mb-3">
          <label for="agree">
            <input
              id="agree"
              v-model="privacy"
              type="checkbox"
              name="agree"
            > <span class="text-sm">点击注册键即表示您同意 Positive Grid 之<a
              class="underline"
              href=""
            >隐私政策</a></span>
          </label>
        </div>
        <div class="mb-3">
          <p
            v-if="inValid"
            class="color-red"
          >
            {{ errorMessage }}
          </p>
        </div>
        <button
          type="submit"
          class="w-full mb-3"
          :disabled="false"
        >
          注册
        </button>
        <div class="flex justify-center">
          <a
            class="underline cursor-pointer text-sm"
            @click="goToIndex($event, LOGIN)"
          >立即登录
          </a>
        </div>
      </form>
    </div>
    <!-- 帐号登录 -->
    <div
      v-if="displayIndex === LOGIN"
      class="login-main flex flex-col text-center"
    >
      <h3 class="text-2xl mb-3">
        帐号登录
      </h3>
      <form
        :id="LOGIN"
        @submit.prevent="submitLoginForm()"
      >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="email"
          name="username"
          placeholder="电子邮箱"
          :class="{'border-red': inValid}"
          required
        >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="password"
          name="password"
          placeholder="密码"
          autocomplete="off"
          :class="{'border-red': inValid}"
          required
        >
        <div class="mb-3">
          <p
            v-if="inValid"
            class="color-red"
          >
            电子邮箱或密码输入错误
          </p>
          <br v-else>
        </div>
        <button
          type="submit"
          class="w-full mb-3"
          :disabled="false"
        >
          登录
        </button>
        <div class="flex justify-center">
          <a
            class="underline cursor-pointer text-sm"
            @click="goToIndex($event, FORGET_PASSWORD)"
          >忘记密码</a>
          <div class="border-l mx-5" />
          <a
            class="underline cursor-pointer text-sm"
            @click="goToIndex($event, REGISTRATION)"
          >立即注册
          </a>
        </div>
      </form>
    </div>
    <!-- 忘记密码 -->
    <div
      v-if="displayIndex === FORGET_PASSWORD"
      class="login-main flex flex-col text-center"
    >
      <h3 class="text-2xl mb-3">
        忘记密码
      </h3>
      <span class="text-sm mb-5">请输入您用于注册的电子邮件地址，我们将向您发送电
        子邮件以重置密码。</span>
      <form
        v-if="!showSuccessfulMsg"
        :id="FORGET_PASSWORD"
        @submit.prevent="submitForgetForm()"
      >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="email"
          name="user_email"
          placeholder="电子邮箱"
          required
        >
        <div class="mb-3">
          &nbsp;
        </div>
        <button
          type="submit"
          class="w-full mb-3"
        >
          送出
        </button>
        <div class="flex justify-center">
          <a
            class="underline cursor-pointer text-sm"
            @click="goToIndex($event, LOGIN)"
          >返回登录页面</a>
        </div>
      </form>
      <div
        v-else
        class="flex justify-center items-center h-40 px-12"
      >
        <img src="@/assets/icons/tick.png">
        <p class="ml-5 text-gray-500">
          代码已发送至您的邮箱，
          请检查该信件以重置密码。
        </p>
      </div>
    </div>
    <!-- 重置密码 -->
    <div
      v-if="displayIndex === RESET_PASSWORD"
      class="login-main flex flex-col text-center"
    >
      <h3 class="text-2xl mb-3">
        重置密码
      </h3>
      <span class="text-sm mb-5">请输入您的新密码</span>
      <form
        v-if="!showSuccessfulMsg"
        :id="RESET_PASSWORD"
        @submit.prevent="submitResetForm()"
      >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="password"
          placeholder="密码"
          autocomplete="off"
          name="reset_password"
          :class="{'border-red': inValid && errorPassword}"
        >
        <input
          class="w-full mb-3 h-8 px-5 border"
          type="password"
          placeholder="请确认密码"
          autocomplete="off"
          :class="{'border-red': inValid && errorPassword}"
        >
        <div class="mb-3">
          <p
            v-if="inValid"
            class="color-red"
          >
            {{ errorMessage }}
          </p>
          <br v-else>
        </div>
        <button
          type="submit"
          class="w-full mb-3"
        >
          登录
        </button>
        <div class="flex justify-center">
          <a
            class="underline cursor-pointer text-sm"
            @click="goToIndex($event, LOGIN)"
          >返回登录页面</a>
        </div>
      </form>
      <div
        v-else
        class="flex justify-center items-center h-40 px-12"
      >
        <img src="@/assets/icons/tick.png">
        <p class="ml-5 text-gray-500">
          密码已重设，请 <a
            class="underline"
            href="/"
          >再次登录</a>
        </p>
      </div>
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/popup-container'

import axios from 'axios'
import { NEW_API_URL } from '@/urls'
import jwtDecode from 'jwt-decode'
// import md5 from 'blueimp-md5'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    PopupContainer
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      displayIndex: null,
      inValid: false,
      showSuccessfulMsg: false,
      password: '',
      confirmPassword: '',
      privacy: false,
      errorMessage: '',
      errorPassword: false,
      errorConfirmPassword: false
    }
  },
  computed: {
    ...mapState('Auth', {
      loggedIn: 'loggedIn',
      tokenInfo: 'info'
    })
  },
  created () {
    this.REGISTRATION = 'REGISTRATION'
    this.RESET_PASSWORD = 'RESET'
    this.FORGET_PASSWORD = 'FORGET_PASSWORD'
    this.LOGIN = 'LOGIN'

    this.displayIndex = this.LOGIN
  },
  mounted () {
    if (this.token) {
      this.displayIndex = this.RESET_PASSWORD
    }
  },
  methods: {
    goToIndex (event, target) {
      event.preventDefault()
      this.displayIndex = target
      setTimeout(() => {
        document.getElementById(target).reset()
      }, 100)

      this.resetStatus()
    },
    clickCloseButton () {
      if (this.displayIndex === this.RESET_PASSWORD) {
        window.location.href = '/'
      } else {
        this.$emit('close')
      }
    },
    convertFormData2Json (formData) {
      const object = {}
      formData.forEach((value, key) => { object[key] = value })
      return JSON.stringify(object)
    },
    ...mapMutations('Auth', {
      storeLogin: 'LOGIN'
    }),
    resetStatus () {
      this.inValid = false
      this.password = ''
      this.confirmPassword = ''
      this.errorMessage = ''
      this.privacy = false
      this.errorPassword = false
    },
    async submitLoginForm (formData) {
      let requestPayLoad = {}

      if (!formData) {
        formData = new FormData(document.getElementById(this.LOGIN))
        requestPayLoad = this.convertFormData2Json(formData)
      } else {
        requestPayLoad['username'] = formData.get('email')
        requestPayLoad['password'] = formData.get('password')
      }

      try {
        await axios.post(
          `${NEW_API_URL}/api/auth`,
          requestPayLoad, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
          console.log('Success!!')
          const token = res.data.token
          window.localStorage.setItem('PG_TOKEN', token)
          const decoded = jwtDecode(token)
          this.storeLogin({
            token,
            info: decoded
          })
          this.inValid = false
          this.$emit('close')
        }).catch(err => {
          console.error('Fail!!', err)
          this.inValid = true
        })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    async submitRegistrationForm () {
      // handle incorrect input
      if (this.password !== this.confirmPassword) {
        this.inValid = true
        this.errorPassword = true
        this.errorMessage = '请输入与设定密码相同之确认密码'
        return false
      } else {
        this.inValid = false
      }

      if (!this.privacy) {
        this.inValid = true
        this.errorPassword = false
        this.errorMessage = '请勾选同意隐私政策'
        return false
      } else {
        this.inValid = false
      }

      const formData = new FormData(document.getElementById(this.REGISTRATION))
      const requestPayLoad = this.convertFormData2Json(formData)

      try {
        await axios.post(
          `${NEW_API_URL}/v2/user`,
          requestPayLoad, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
          console.log('Success!!')
          this.inValid = false
          this.resetStatus()
          this.submitLoginForm(formData)
        }).catch(err => {
          console.error('Fail!!', err)
          this.inValid = true
          this.errorMessage = '此帐号已经存在'
        })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    async submitForgetForm () {
      const formData = new FormData(document.getElementById(this.FORGET_PASSWORD))
      const requestPayLoad = this.convertFormData2Json(formData)

      try {
        await axios.post(
          `${NEW_API_URL}/api/req_reset_pwd`,
          requestPayLoad, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
          console.log('Success!!')
          this.inValid = false
          this.showSuccessfulMsg = true
        }).catch(err => {
          console.error('Fail!!', err)
          this.inValid = true
        })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    async submitResetForm () {
      // handle incorrect input
      if (this.password !== this.confirmPassword) {
        this.inValid = true
        this.errorPassword = true
        this.errorMessage = '请输入与设定密码相同之确认密码'
        return false
      } else {
        this.inValid = false
      }

      const formData = new FormData(document.getElementById(this.RESET_PASSWORD))
      const requestPayLoad = this.convertFormData2Json(formData)

      try {
        await axios.put(
          `${NEW_API_URL}/api/do_reset_pwd/${this.token}`,
          requestPayLoad, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
          console.log('Success!!')
          this.inValid = false
          this.showSuccessfulMsg = true
        }).catch(err => {
          console.error('Fail!!', err)
          this.inValid = true
        })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$bg-color: #282828;
$text-red: #d92f13;

.login-main {
  h3 {
    color: #d7d7d7;
  }

  input {
    background-color: $bg-color;
    border-color: #5f5f5f;
  }

  .color-red {
    color: $text-red;
  }

  .border-red {
    border-color: $text-red;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login-window.vue